import React, {useState, useEffect} from "react";
import Modal from 'react-bootstrap/Modal';
import { alertResponseMessage } from "../../actions/action-creators/response";
import { post_api_call, error_api_call, downloadBlobCreatedFile } from "../../actions/action-creators/common";
import FormDataCouncil from "../../data/formData/esg/council-content";
import ValidationHelper from "../../helper/validation";
import ModalMaster from "../master";
const {
    levelOptions,
    fieldValuesExcel,
    fieldExcelContent,
    fieldValidationExcel
} = FormDataCouncil;

// Bulk update of the ESG council content from Excel (councilNumber, individualTask, guidelines, learning per row) for the chosen level.
// Same flow and result layout as the ESG student level Excel upload: pick the level and the file, submit, then a result modal with a
// failed table and a success table; failed rows are also downloaded as an Excel file with the reason.
function EsgCouncilContentExcelModal(props) {
    const [showResModal, setShowResModal] = useState(false);
    const [userData, setUserData] = useState(fieldValuesExcel);
    const [isProcess, setIsProcess] = useState(false);
    const [errorData, setErrorData] = useState([]);
    const [successRows, setSuccessRows] = useState([]);
    const [failedRows, setFailedRows] = useState([]);

    useEffect(() => {
        setUserData(fieldValuesExcel);
        setErrorData([]);
        setIsProcess(false);
        setSuccessRows([]);
        setFailedRows([]);
    }, [props.isShow]);// eslint-disable-line react-hooks/exhaustive-deps

    const updateInput = (field, value) => {
        const updated = {...userData, [field]: value};
        if(field === "excel_file"){
            updated.excel_file_data = value.files;
            updated.excel_file = value?.value;
        }
        setUserData(updated);
    };

    const _submitForm = async(e) => {
        try{
            e.preventDefault();
            setIsProcess(true);
            setErrorData([]);
            const validation = ValidationHelper.validation(userData, fieldValidationExcel).error;
            if(validation.length){
                setErrorData(validation);
                setIsProcess(false);
                return;
            }
            const apiFormData = new FormData();
            apiFormData.append('excel_file', userData.excel_file_data[0]);
            apiFormData.append('level', String(userData.level_id?.id));
            const apiData = await post_api_call('esg-council-content/upload', apiFormData);
            if(apiData.status === 200){
                const failed = apiData.results.filter(r => r.result === 'failed');
                const succeeded = apiData.results.filter(r => r.result !== 'failed');
                const changed = succeeded.filter(r => r.result !== 'unchanged');
                if(failed.length === 0 && changed.length === 0){
                    // Every row already matched: nothing changed, so no result table.
                    alertResponseMessage({alert_type: 3, message: apiData.message});
                    setIsProcess(false);
                    return;
                }
                alertResponseMessage({alert_type: failed.length ? 2 : 1, message: apiData.message});
                if(changed.length > 0){
                    props._resetListing();
                }
                if(succeeded.length > 0){
                    setSuccessRows(succeeded);
                }
                if(failed.length > 0){
                    setFailedRows(failed);
                    //automatically download data in Excel File
                    const apiExcelData = await post_api_call('sample/failed',
                                                        {data: {
                                                            data: failed.map(r => [r.row, r.council_number, r.message]),
                                                            // The export adds its own trailing "Reason" column.
                                                            headers: ['Excel Row', 'Council Number'],
                                                            sheet_name: "ESG Council Content"},
                                                        file_name: "Failed-ESG-Council-Content-Data.xlsx"
                                                    }, true, 'blob');
                    if(apiExcelData.status === 200){
                        downloadBlobCreatedFile(apiExcelData, `Failed-ESG-Council-Content-Data.xlsx`);
                    }
                }
                setShowResModal(true);
            }else if(apiData.message){
                setErrorData([apiData.message]);
            }
            setIsProcess(false);
        }catch(error){
            setIsProcess(false);
            console.error(error);
            alertResponseMessage({alert_type: 2, message: "Error updating council content! Please try after some time"});
            error_api_call({error: `modal/esg/council-content-excel|_submitForm|${error}`});
        }
    };

    const resultTable = (rows, headClass, tableClass, statusTitle) => (
        <div className={`row m-0 table-responsive table ${tableClass}`}>
            <table className="table-bordered">
                <thead className={headClass}>
                    <tr>
                        <th>Excel Row No.</th>
                        <th>{statusTitle}</th>
                        <th>Council Number</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, idx) => (
                        <tr key={`${statusTitle}_${idx}`}>
                            <td>{row.row}</td>
                            <td><b>{row.message}</b></td>
                            <td>{row.council_number}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

    return (
        <>
        {(failedRows.length > 0
            || successRows.length > 0
        )
        ?
            <Modal dialogClassName="modal-70w modal-dialog-scrollable" show={showResModal} onHide={(e) => {setShowResModal(false); props._toggleModal(e, false);}} size="md" className="mod-custom team-detail" backdrop="static">
                <Modal.Header closeButton>Excel Upload Result</Modal.Header>
                <Modal.Body>
                    {failedRows.length > 0 && (
                        <fieldset>
                            <legend>Failed Data ({failedRows.length})</legend>
                            {resultTable(failedRows, "table-secondary", `table-danger ${successRows.length > 0 ? 'scroll-div-30vh' : ''}`, "Reason")}
                        </fieldset>
                    )}
                    {successRows.length > 0 && (
                        <fieldset>
                            <legend>Updated Councils ({successRows.length})</legend>
                            {resultTable(successRows, "table-secondary", `table-success ${failedRows.length > 0 ? 'scroll-div-30vh' : ''}`, "Status")}
                        </fieldset>
                    )}
                </Modal.Body>
                <Modal.Footer className="team-detail">
                    <button className="btn btn-secondary" onClick={(e) => {setShowResModal(false); props._toggleModal(e, false);}}>Close</button>
                </Modal.Footer>
            </Modal>
        :
            <ModalMaster
                isShow={props.isShow}
                _toggleModal={(e, state) => props._toggleModal(e, state)}
                formType={'excel_content'}
                data={userData}
                title={"ESG Council Content (Excel)"}
                _errorData={{excel_content: errorData}}
                _isProcess={{excel_content: isProcess}}
                _updateInput= {(form_type, variable_type, input_type, field, value) => updateInput(field, value)}
                _submitForm={(e, form_type) => _submitForm(e)}
                _formData={[{form_type: 'excel_content', label: 'Details', fields: [...fieldExcelContent]}]}
                selectOptions={{level_id: {value: 'id', label: 'label', data: [...levelOptions]}}}
            />
        }
        </>
    );
}

export default EsgCouncilContentExcelModal;
